













import {defineComponent} from '@nuxtjs/composition-api';

export default defineComponent({
  name: "HeaderPromotionBlock",
  components: {
    StaticBlock: () => import(/* webpackMode: "lazy" */ '~/components/Palmers/BaseComponents/Cms/StaticBlock.vue'),
  },
  data: () => ({
    showed: true
  }),
  props: {
    promotionBlock: {
      type: [Object, Boolean],
      require: true
    }
  }
});
